import React from "react";
import VisitTracker from "./components/VisitTracker";
import { CartProvider } from "./context/CartContext";
import PortalAccess from "./components/PortalAccess";
import { BrowserRouter as Router, Routes, Route, Navigate, useSearchParams } from "react-router-dom";
import { customerHomePath } from './lib/customerHome';
import CustomerLayout from "./components/layout/CustomerLayout";
import Legals from "./components/layout/Legals";
import Home from "./pages/customer/Home";
import CustomerAreaPrompt from './components/CustomerAreaPrompt';
import LocalDiscovery from "./pages/customer/LocalDiscovery";
import VendorStore from "./pages/customer/VendorStore";
import ProductDetail from "./pages/customer/ProductDetail";
import Search from "./pages/customer/Search";
import Cart from "./pages/customer/Cart";
import Checkout from "./pages/customer/Checkout";
import AccountVerification from "./pages/customer/AccountVerification";
import Profile from "./pages/customer/Profile";
import Orders from "./pages/customer/Orders";
import OrderDetails from "./pages/customer/OrderDetails";
import PaymentResult from "./pages/customer/PaymentResult";
import VendorApplication from "./components/VendorApplication";
import Auth from "./pages/Auth";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import ToastContainer from "./components/ui/ToastContainer";
import PrivateRoute from "./components/PrivateRoute";
function MarketplaceEntry() {
  const [params] = useSearchParams();
  return params.has('area') || customerHomePath === '/' ? <Home /> : <Navigate to={customerHomePath} replace />;
}
export default function App() { return <Router><AuthProvider><CustomerAreaPrompt /><VisitTracker /><CartProvider><ToastProvider><Routes>
<Route path="/auth" element={<Auth />} />
<Route path="/legals" element={<Legals />} />
<Route element={<CustomerLayout />}>
              <Route path="/cart" element={<Cart />} />
              {/* Home */}
              <Route path="/" element={<MarketplaceEntry />} />
              <Route path="/:areaSlug/" element={<LocalDiscovery />} />
              <Route path="/:areaSlug/category/:categorySlug" element={<LocalDiscovery />} />
              <Route path="/food-delivery" element={<LocalDiscovery />} />
              <Route path="/food-delivery/:areaSlug" element={<LocalDiscovery />} />
              <Route path="/food-delivery/:areaSlug/:categorySlug" element={<LocalDiscovery />} />

              {/* Search */}
              <Route path="/search" element={<Search />} />

              {/* Product detail */}
              <Route
                path="/vendor/:vendorSlug/product/:productSlug"
                element={<ProductDetail />}
              />

              {/* Vendor store */}
              <Route path="/vendor/:vendorSlug" element={<VendorStore />} />
              <Route path="/:areaSlug/:vendorSlug/" element={<VendorStore />} />
              <Route path="/:areaSlug/:vendorSlug/product/:productSlug" element={<ProductDetail />} />
            </Route>
<Route element={<PrivateRoute allowedRoles={["CUSTOMER"]} />}>
              <Route element={<CustomerLayout />}>
                {/* Cart */}


                {/* Checkout */}
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/checkout/payment" element={<PaymentResult />} />

                {/* Profile */}
                <Route path="/profile" element={<Profile />} />
                <Route path="/vendor-setup" element={<VendorApplication setup />} />
                <Route path="/account-verification" element={<AccountVerification />} />

                {/* Orders */}
                <Route path="/orders" element={<Orders />} />

                {/* Order Details */}
                <Route path="/orders/:id" element={<OrderDetails />} />
              </Route>
            </Route>

<Route path="*" element={<PortalAccess />} /></Routes><ToastContainer /></ToastProvider></CartProvider></AuthProvider></Router>; }
